import { ShortCode } from '@highereducation/wordpress';
import {
  TimelineEvent,
  type TimelineEventProps,
} from '@highereducation/hen-ui';
import { isTimelineMarkerColor } from '../utils';

type TimelineEventShortcodeProps = {
  title: string;
  index: string;
  color?: string;
  children: TimelineEventProps['children'];
};

export const TimelineEventShortcode: ShortCode<TimelineEventShortcodeProps> = {
  component: ({ title, children, index, color }) => {
    return (
      <TimelineEvent
        title={title}
        index={parseInt(index, 10)}
        color={isTimelineMarkerColor(color) ? color : undefined}
      >
        {children}
      </TimelineEvent>
    );
  },
};
